import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { appStore, googlePlay } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="25px" column center>
          <CFView h3 futura bold color="#FFFFFF" mb="20px">
            DOWNLOAD APP
          </CFView>
          <CFView column center white bold>
            <CFView h4 mb="25px" textCenter maxWidth="75vw">
              Sapporo Japanese Kitchen is now taking online orders. Order
              through our website or download our app in your app store! Collect
              points and redeem fantastic rewards!
            </CFView>
            <CFView row center>
              <CFView mr="10px">
                <CFLink href="https://apps.apple.com/us/app/sapporo-kitchen/id1572942913">
                  <CFImage
                    h="40px"
                    src={appStore}
                    alt="Sapporo Japanese Kitchen App Store"
                  />
                </CFLink>
              </CFView>
              <CFLink href="https://play.google.com/store/apps/details?id=tech.codefusion.sapporo">
                <CFImage
                  h="40px"
                  src={googlePlay}
                  alt="Sapporo Japanese Kitchen Google Play"
                />
              </CFLink>
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mr="25px" column justifyStart>
          <CFView h3 futura bold color="#FFFFFF" mb="20px" minWidth="250px">
            DOWNLOAD APP
          </CFView>
          <CFView column justifyStart white bold>
            <CFView maxWidth="260px" fontSize="14px" mb="15px">
              Sapporo Japanese Kitchen is now taking online orders. Order
              through our website or download our app in your app store! Collect
              points and redeem fantastic rewards!
            </CFView>
            <CFLink href="https://apps.apple.com/us/app/sapporo-kitchen/id1572942913">
              <CFImage
                h="37px"
                mt="5px"
                src={appStore}
                alt="Sapporo Japanese Kitchen App Store"
                hover
              />
            </CFLink>
            <CFLink href="https://play.google.com/store/apps/details?id=tech.codefusion.sapporo">
              <CFImage
                h="37px"
                mt="5px"
                src={googlePlay}
                alt="Sapporo Japanese Kitchen Google Play"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
